import React from 'react';
import { useDropzone } from 'react-dropzone';

export const FileUpload = ({ onFileUpload, allowed="image/*, application/pdf", maxFiles=1, uploadText="Upload a file" }) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: 'image/*, application/pdf',
    maxFiles: maxFiles, // Set the maximum number of files allowed
    onDrop: (acceptedFiles) => {
      onFileUpload(acceptedFiles);
    },
  });

  return (
    <div className="border border-dashed rounded-lg bg-gray-100 border-gray-400 p-5 mt-2">
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <p className="text-sm text-gray-500">{uploadText}</p>
      </div>
      {acceptedFiles.length > 0 && (
        acceptedFiles.map((acceptedFile)=>(<div className="mt-2">
          <strong>Selected File:</strong> {acceptedFile.name}
        </div>
      )))}
    </div>
  );
};
